export default __webpack_public_path__ + "static/media/French(CA).3193914d.svg";